import React from 'react'
import { compact, omit } from 'lodash'

import { Link } from 'core'

import css from './style.scss'

const VIEWS = [
  { value: 'index', label: 'List' },
  { value: 'calendar', label: 'Calendar' }
]

/**
 * Links rather than tabs: each one changes the URL, so it should behave like a
 * link for keyboard, middle-click and screen-reader users alike.
 */
const EventsViewToggle = ({ activeView, query }) => (
  <nav aria-label='Event view' className={css.viewToggle}>
    {VIEWS.map(view => {
      // The month only means something in the calendar, so drop it on the way
      // back to the list; the type filter carries across both.
      const nextQuery = view.value === 'calendar'
        ? { ...query, view: 'calendar' }
        : omit({ ...query, view: undefined }, ['view', 'month'])

      return (
        <Link key={view.value} to={{ pathname: '/events', query: nextQuery }}>
          <span
            className={compact([
              css.viewToggleOption,
              view.value === activeView ? css.viewToggleActive : null
            ]).join(' ')}
            aria-current={view.value === activeView ? 'page' : null}
          >
            {view.label}
          </span>
        </Link>
      )
    })}
  </nav>
)

EventsViewToggle.propTypes = {
  activeView: React.PropTypes.oneOf(['index', 'calendar']).isRequired,
  query: React.PropTypes.object
}

EventsViewToggle.defaultProps = {
  query: {}
}

export default EventsViewToggle
